'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getPersonalDetail(context, params = {}) {
    const defaultData = { addresses: [], emergencyContacts: [], employeeDetails: {}, employeeInformation: {}, families: [], hisotyrSalary: [], historyMembership: [], historyTaxMethod: [], historyTaxStatus: [], workExperiences: [], }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/personaldetails`
        const result = await axios.get(url, {
          ...costumHeader('Get Personal Detail', 4),
          params,
          timeout: 15000
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  uploadComponentTemplate(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
       const headers =  { headers: {'Content-Type': `multipart/form-data`}}
        const url = `${baseUrl}/v3/payroll/uploadComponentTemplate`
        const result = await axios.post(url, body, headers)
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  getPayrollComponent(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollcomponents`
        const result = await axios.get(url, {
          ...costumHeader('Get Payroll Component', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  savePayrollComponent(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollcomponents`
        const result = await axios.post(url, body, costumHeader('Save Payroll Component', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editPayrollComponent(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollcomponents/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Payroll Component', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deletePayrollComponent(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollcomponents/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Payroll Component', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }